import { useState, useEffect } from 'react';
import homePageService from '../../../services/homePageService';
import './AdminSlider.css';

const AdminSlider = () => {
  const [sliderData, setSliderData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [editingSlide, setEditingSlide] = useState(null);
  const [showAddForm, setShowAddForm] = useState(false);
  const [newSlide, setNewSlide] = useState({ imagePreview: '', url: '' });

  useEffect(() => { fetchData(); }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const content = await homePageService.getHomePageContent();
      if (content.sliderData) setSliderData(content.sliderData);
    } catch { setError('Veriler yüklenemedi.'); }
    finally { setLoading(false); }
  };

  const save = async (data) => {
    try {
      await homePageService.updateHomePageContent({ sliderData: data });
      setSliderData(data);
      return true;
    } catch (err) {
      setError('Kaydetme başarısız.');
      return false;
    }
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    if (!newSlide.imagePreview) { setError('Resim seçin.'); return; }
    const maxId = sliderData.length > 0 ? Math.max(...sliderData.map(s => s.id)) : 0;
    if (await save([...sliderData, { id: maxId + 1, image: newSlide.imagePreview, url: newSlide.url || '#' }])) {
      setSuccess('Slayt eklendi.');
      setShowAddForm(false);
      setNewSlide({ imagePreview: '', url: '' });
      fetchData();
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Slaytı silmek istediğinizden emin misiniz?')) return;
    setError(''); setSuccess('');
    if (await save(sliderData.filter(s => s.id !== id))) setSuccess('Slayt silindi.');
  };

  const handleSaveEdit = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    const data = sliderData.map(s => s.id === editingSlide.id ? { id: s.id, image: editingSlide.newImage || s.image, url: editingSlide.url } : s);
    if (await save(data)) { setSuccess('Slayt güncellendi.'); setEditingSlide(null); fetchData(); }
  };

  const handleFile = (e, target) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      if (target === 'new') setNewSlide({ ...newSlide, imagePreview: reader.result });
      else setEditingSlide({ ...editingSlide, newImage: reader.result });
    };
    reader.readAsDataURL(file);
  };

  if (loading) return <div className="admin-slider-empty">Yükleniyor...</div>;

  return (
    <div className="admin-slider">
      {success && <div className="admin-slider-success">{success}</div>}
      {error && <div className="admin-slider-error">{error}</div>}

      <div className="admin-slider-card">
        <div className="admin-slider-header">
          <h3>Slider ({sliderData.length} slayt)</h3>
          <button className="admin-slider-add-btn" onClick={() => { setShowAddForm(!showAddForm); setEditingSlide(null); }}>+ Yeni Slayt</button>
        </div>

        {showAddForm && (
          <form className="admin-slider-form" onSubmit={handleAdd}>
            <h4>Yeni Slayt Ekle</h4>
            <div className="admin-slider-form-group">
              <label>Resim</label>
              <input type="file" accept="image/*" onChange={(e) => handleFile(e, 'new')} />
              {newSlide.imagePreview && <img src={newSlide.imagePreview} alt="Önizleme" className="admin-slider-preview" />}
            </div>
            <div className="admin-slider-form-group">
              <label>URL</label>
              <input type="text" value={newSlide.url} onChange={(e) => setNewSlide({ ...newSlide, url: e.target.value })} placeholder="/cizelgeler" />
            </div>
            <div className="admin-slider-form-actions">
              <button type="submit" className="admin-slider-btn-save">Ekle</button>
              <button type="button" className="admin-slider-btn-cancel" onClick={() => setShowAddForm(false)}>İptal</button>
            </div>
          </form>
        )}

        {editingSlide && (
          <form className="admin-slider-form" onSubmit={handleSaveEdit}>
            <h4>Slayt Düzenle</h4>
            <div className="admin-slider-form-group">
              <label>Resim</label>
              <img src={editingSlide.newImage || editingSlide.image} alt="Mevcut" className="admin-slider-preview" />
              <input type="file" accept="image/*" onChange={(e) => handleFile(e, 'edit')} style={{ marginTop: '0.5rem' }} />
            </div>
            <div className="admin-slider-form-group">
              <label>URL</label>
              <input type="text" value={editingSlide.url} onChange={(e) => setEditingSlide({ ...editingSlide, url: e.target.value })} />
            </div>
            <div className="admin-slider-form-actions">
              <button type="submit" className="admin-slider-btn-save">Kaydet</button>
              <button type="button" className="admin-slider-btn-cancel" onClick={() => setEditingSlide(null)}>İptal</button>
            </div>
          </form>
        )}

        {sliderData.length > 0 ? (
          <div className="admin-slider-grid">
            {sliderData.map((slide, i) => (
              <div key={slide.id} className="admin-slider-item">
                <img src={slide.image} alt={`Slayt ${i + 1}`} />
                <div className="admin-slider-item-info">
                  <p className="admin-slider-item-url">URL: {slide.url}</p>
                  <div className="admin-slider-item-actions">
                    <button className="admin-slider-btn-edit" onClick={() => { setEditingSlide({ ...slide, newImage: null }); setShowAddForm(false); }}>Düzenle</button>
                    <button className="admin-slider-btn-delete" onClick={() => handleDelete(slide.id)}>Sil</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : <div className="admin-slider-empty">Henüz slayt yok.</div>}
      </div>
    </div>
  );
};

export default AdminSlider;
